"use strict";
/* eslint compat/compat:"off" */
Object.defineProperty(exports, "__esModule", { value: true });
exports.now = void 0;
exports.now = typeof performance !== 'undefined' && performance && typeof performance.now === 'function'
    ? function () { return performance.now(); }
    : Date.now;
//# sourceMappingURL=util.now.js.map